import fetch from '../utils/fetch';

export default {
  // 获取会员卡领卡投放链接
  alipaycardGetActivateUrl() {
    return fetch.get(`/soyoung/api/alipaycardbiz/getActivateUrl`);
  },
  // 确认领卡
  alipaycardCreateAlipayCard(params) {
    return fetch.post(`/soyoung/api/alipaycardbiz/createAlipayCard`, params);
  },
};
